import {
  apiAxios
} from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //商品核查跟进-列表
  followList: (data) => apiAxios('post', baseURL + '/follow.followList', data),
  //核查跟进-配货工作状况
  dataSpeedPlist: (data) => apiAxios('post', baseURL + '/data.dataSpeedP.list', data),

  // 修改单番商品备注
  updateOrderDetailRemark: (data) => apiAxios('post', baseURL + '/follow.updateOrderDetailRemark', data),

  //核查-上架预览
  upPreview: (data) => apiAxios('post', baseURL + '/follow.upPreview', data),
  //核查-开始核查
  startChecking: (data) => apiAxios('post', baseURL + '/follow.startChecking', data),
  //核查-上架提交
  followUpStorage: (data) => apiAxios('post', baseURL + '/follow.upStorage', data),
  //核查-查询某些番总的提出到配送单的数量
  orderDetailTotalPorderNum: (data) => apiAxios('post', baseURL + '/follow.orderDetailTotalPorderNum', data),

  // 直接装箱-获取箱子列表
  boxList: (data) => apiAxios('post', baseURL + '/box.boxList', data),
  // 直接装箱-添加空箱子
  addBoxBatch: (data) => apiAxios('post', baseURL + '/box.addBoxBatch', data),
  // 直接装箱-箱规修改
  updateBoxAttr: (data) => apiAxios('post', baseURL + '/box.updateBoxAttr', data),
  // 直接装箱-箱子重量修改
  updateBoxWeight: (data) => apiAxios('post', baseURL + '/box.updateBoxWeight', data),
  // 直接装箱-删除箱子
  deleteBox: (data) => apiAxios('post', baseURL + '/box.deleteBox', data),
  // 直接装箱-标记装箱完了
  toComplete: (data) => apiAxios('post', baseURL + '/box.toComplete', data),
  // 直接装箱-装箱完了回退
  toUnComplete: (data) => apiAxios('post', baseURL + '/box.toUnComplete', data),
  // 直接装箱-装箱
  intoBox: (data) => apiAxios('post', baseURL + '/box.intoBox', data),
  // 直接装箱-箱子详情
  boxDetail: (data) => apiAxios('post', baseURL + '/box.boxDetail', data),
  // 直接装箱-从箱子取出
  outBox: (data) => apiAxios('post', baseURL + '/box.outBox', data),
  // 直接装箱-移箱
  moveOut: (data) => apiAxios('post', baseURL + '/box.moveOut', data),
  // 直接装箱--修改备注
  updatePRemark: (data) => apiAxios('post', baseURL + '/box.updatePRemark', data),
  // 直接装箱--修改备注
  updateYRemark: (data) => apiAxios('post', baseURL + '/box.updateYRemark', data),
  // 直接装箱-修改箱规及重量
  updateBoxAttrAndWeight: (data) => apiAxios('post', baseURL + '/box.updateBoxAttrAndWeight', data),


  /* 检品*/
  // 创建检品单
  inspectStore: (data) => apiAxios('post', baseURL + '/inspect.store', data),
  // 添加商品到检品单
  inspectStoreDetail: (data) => apiAxios('post', baseURL + '/inspect.storeDetail', data),
  // 核查界面获取未提交检品的检品单列表
  inspectUnAllotList: (data) => apiAxios('post', baseURL + '/inspect.unAllotList', data),
  // 检品详情状态MAP
  inspectStatusMap: (data) => apiAxios('post', baseURL + '/inspect.statusMap', data),
  // 通用.检品单列表
  inspectList: (data) => apiAxios('post', baseURL + '/inspect.inspectList', data),
  // 检品单-列表-tab数量统计
  inspectListTab: (data) => apiAxios('post', baseURL + '/inspect.inspectListTab', data),
  // 检品单详情
  inspectDetail: (data) => apiAxios('post', baseURL + '/inspect.detail', data),
  // 修改检品单备注
  inspectUpdateRemark: (data) => apiAxios('post', baseURL + '/inspect.updateRemark', data),
  // 从检品单移除
  inspectRemoveDetail: (data) => apiAxios('post', baseURL + '/inspect.removeDetail', data),
  // 检品单废弃
  inspectDiscard: (data) => apiAxios('post', baseURL + '/inspect.discard', data),
  // 检品单拆分
  inspectSplit: (data) => apiAxios('post', baseURL + '/inspect.split', data),
  // 检品操作界面数据预览
  inspectPreview: (data) => apiAxios('post', baseURL + '/inspect.inspectPreview', data),
  // 检品单调配
  inspectDispatchAdmin: (data, config) => apiAxios('post', baseURL + '/inspect.dispatchAdmin', data, config),
  // 检品单提交(自动分配检品员)
  inspectSubmitInspect: (data) => apiAxios('post', baseURL + '/inspect.submitInspect', data),
  // 检品员-开始普检/精检
  inspectStartInspect: (data) => apiAxios('post', baseURL + '/inspect.startInspect', data),
  // 检品员-开始布标处理
  inspectStartLabel: (data) => apiAxios('post', baseURL + '/inspect.startLabel', data),
  //检品操作界面-普检/精检提出临时不良
  inspectBadTemp: (data) => apiAxios('post', baseURL + '/inspect.inspectBadTemp', data),
  // 检品操作界面-提交给布标处理
  inspectToWaitLabel: (data) => apiAxios('post', baseURL + '/inspect.toWaitLabel', data),
  //检品操作界面-布标处理提交
  inspectSubmitLabel: (data) => apiAxios('post', baseURL + '/inspect.submitLabel', data),
  //检品操作界面-提交检品完
  inspectSave: (data) => apiAxios('post', baseURL + '/inspect.inspectSave', data),
  //检品操作界面-普检/精检临时保存
  inspectSaveTemp: (data) => apiAxios('post', baseURL + '/inspect.inspectSaveTemp', data),

  //修改普检/精检数
  updateNum: (data) => apiAxios('post', baseURL + '/inspect.updateNum', data),
  //修改布标处理数
  updateLabelShouldNum: (data) => apiAxios('post', baseURL + '/inspect.updateLabelShouldNum', data),
  //检品单拆分
  inspectSplit: (data) => apiAxios('post', baseURL + '/inspect.split', data),
  // 不良品列表
  badList: (data) => apiAxios('post', baseURL + '/inspect.badList', data),
  // 不良码标记为已打印
  badMarkPrint: (data) => apiAxios('post', baseURL + '/inspect.badMarkPrint', data),
  //不良品列表-不良确认
  badConfirm: (data) => apiAxios('post', baseURL + '/inspect.badConfirm', data),
  // 检品-提出复检单
  recheckInspectCreate: (data) => apiAxios('post', baseURL + '/inspect.recheckInspectCreate ', data),

  // 检品-直接复检单复检单直接创建（基于采购记录）
  recheckInspectCreateDirect: (data) => apiAxios('post', baseURL + '/inspect.recheckInspectCreateDirect', data),
  // 检品-复检单原因选项MAP
  recheckReasonMap: (data) => apiAxios('post', baseURL + '/inspect.recheckReasonMap', data),
  // 查看单条采购记录全部检品记录列表(目前,问题产品用)
  inspectListByPurchase: (data) => apiAxios('post', baseURL + '/inspect.inspectListByPurchase', data),
  // 检品单调配布标人员
  dispatchLabelAdmin: (data) => apiAxios('post', baseURL + '/inspect.dispatchLabelAdmin', data),

  // 检品-修改检品单是否需要计算绩效
  switchInspectNeedPerformance: (data) => apiAxios('post', baseURL + '/inspect.switchInspectNeedPerformance', data),


  //服务单
  // 服务单-可选检品操作人员
  usableAdminList: (data) => apiAxios('post', baseURL + '/optionService.usableAdminList', data),
  // 服务单-新增预览
  optionServicePreview: (data) => apiAxios('post', baseURL + '/optionService.preview', data),
  // 服务单-新增服务单保存
  optionServiceStore: (data) => apiAxios('post', baseURL + '/optionService.store', data),
  // 服务单-变更服务单操作人员
  updateAdminId: (data) => apiAxios('post', baseURL + '/optionService.updateAdminId', data),
  // 服务单-删除
  optionServiceDelete: (data) => apiAxios('post', baseURL + '/optionService.delete', data),
  // 服务单-开始处理
  optionServiceStart: (data) => apiAxios('post', baseURL + '/optionService.start', data),
  // 服务单-提交保存
  optionServiceCompleteSave: (data) => apiAxios('post', baseURL + '/optionService.completeSave', data),
  // 服务单-检品生成服务单
  inspectStoreService: (data) => apiAxios('post', baseURL + '/optionService.inspectStoreService', data),
  // 服务单-列表tab数量
  listTabCount: (data) => apiAxios('post', baseURL + '/optionService.listTabCount', data),
  // 服务单-列表
  optionServiceList: (data) => apiAxios('post', baseURL + '/optionService.list', data),
}
